// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notifications[data-v-1fd1f2bf]{display:flex;flex-direction:column}@media(max-width:960px){.notifications[data-v-1fd1f2bf]{align-items:center}}.notifications .manage-notifications[data-v-1fd1f2bf]{display:flex;align-content:center;margin-top:20px;align-items:center;justify-content:center}", ""]);
// Exports
module.exports = exports;
